/*
 * "Recently viewed" strip.
 *
 * Keeps a list of viewed product handles in localStorage and renders the most
 * recent ones as real product cards via the Section Rendering API. The section
 * stays hidden unless at least `data-min` other products have been viewed.
 */
if (!customElements.get('recently-viewed-products')) {
  customElements.define(
    'recently-viewed-products',
    class RecentlyViewedProducts extends HTMLElement {
      constructor() {
        super();
        this.storageKey = 'stg:recently-viewed';
      }

      connectedCallback() {
        this.currentHandle = this.dataset.currentHandle;
        this.limit = parseInt(this.dataset.limit, 10) || 5;
        this.min = parseInt(this.dataset.min, 10) || 2;
        this.cardSection = this.dataset.cardSection;
        this.strip = this.querySelector('[data-strip]');

        // Read the list *before* recording this product so the current PDP is
        // never shown in its own strip.
        const previous = this.read().filter((handle) => handle !== this.currentHandle);
        this.record(this.currentHandle);

        if (previous.length < this.min) return;

        this.render(previous.slice(0, this.limit));
      }

      read() {
        try {
          const raw = localStorage.getItem(this.storageKey);
          const parsed = raw ? JSON.parse(raw) : [];
          return Array.isArray(parsed) ? parsed.filter((h) => typeof h === 'string') : [];
        } catch (e) {
          return [];
        }
      }

      record(handle) {
        if (!handle) return;
        try {
          const list = [handle, ...this.read().filter((h) => h !== handle)].slice(0, 12);
          localStorage.setItem(this.storageKey, JSON.stringify(list));
        } catch (e) {
          /* storage unavailable (private mode / full) — strip just won't populate */
        }
      }

      async render(handles) {
        const cards = await Promise.all(handles.map((handle) => this.fetchCard(handle)));
        const found = cards.filter(Boolean);

        // Products can be unpublished or deleted since they were viewed.
        if (found.length < this.min) return;

        found.forEach((html) => {
          const li = document.createElement('li');
          li.className = 'recently-viewed__item';
          li.innerHTML = html;
          this.strip.appendChild(li);
        });

        this.hidden = false;
      }

      async fetchCard(handle) {
        try {
          const response = await fetch(`${Shopify.routes.root}products/${handle}?section_id=${this.cardSection}`);
          if (!response.ok) return null;

          const text = await response.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const card = doc.querySelector('.card-wrapper');
          return card ? card.outerHTML : null;
        } catch (e) {
          return null;
        }
      }
    }
  );
}
